import { useCallback, useReducer } from 'react';
function createReducer() {
    return function reducer(state, action) {
        var _a;
        switch (action.type) {
            case 'select-all':
                return (_a = action.results) !== null && _a !== void 0 ? _a : state;
            case 'reset':
                return [];
            case 'toggle': {
                if (!action.payload)
                    return state;
                const entityArray = Array.isArray(action.payload) ? action.payload : [action.payload];
                const entityIds = entityArray.map((entity) => entity.entityId);
                const stateWithoutPayload = state.filter((item) => !entityIds.includes(item.entityId));
                if (stateWithoutPayload.length === state.length) {
                    return [...state, ...entityArray];
                }
                return stateWithoutPayload;
            }
            default:
                return state;
        }
    };
}
export function useSelected(results) {
    const reducer = createReducer();
    const [state, dispatch] = useReducer(reducer, []);
    const setSelected = useCallback((action) => dispatch(Object.assign(Object.assign({}, action), { results })), [results]);
    return [state, setSelected];
}
